const sameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

const time = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });
const dayMonth = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
const dayMonthYear = new Intl.DateTimeFormat('fr-FR', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});
const full = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'full', timeStyle: 'short' });

function addDays(date: Date, days: number) {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
}

/** « Aujourd'hui, 18:00 », « Demain, 08:00 », « 12 nov., 09:30 »… */
export function formatReminder(iso: string, now = new Date()): string {
  const date = new Date(iso);
  const hm = time.format(date);
  if (sameDay(date, now)) return `Aujourd'hui, ${hm}`;
  if (sameDay(date, addDays(now, 1))) return `Demain, ${hm}`;
  if (sameDay(date, addDays(now, -1))) return `Hier, ${hm}`;
  const day = date.getFullYear() === now.getFullYear() ? dayMonth : dayMonthYear;
  return `${day.format(date)}, ${hm}`;
}

/** « Modifiée : 14:32 » / « Modifiée : hier, 09:10 » / « Modifiée : 3 oct. » */
export function formatEdited(iso: string, now = new Date()): string {
  const date = new Date(iso);
  if (sameDay(date, now)) return time.format(date);
  if (sameDay(date, addDays(now, -1))) return `hier, ${time.format(date)}`;
  return date.getFullYear() === now.getFullYear()
    ? dayMonth.format(date)
    : dayMonthYear.format(date);
}

export const formatFull = (iso: string) => full.format(new Date(iso));

/** Préréglages de rappel, comme dans Keep. */
export function reminderPresets(now = new Date()) {
  const at = (base: Date, hours: number) => {
    const d = new Date(base);
    d.setHours(hours, 0, 0, 0);
    return d;
  };
  const presets: Array<{ label: string; detail: string; date: Date }> = [];
  const tonight = at(now, 20);
  if (tonight.getTime() - now.getTime() > 30 * 60 * 1000) {
    presets.push({ label: 'Plus tard dans la journée', detail: '20:00', date: tonight });
  }
  presets.push({ label: 'Demain', detail: '08:00', date: at(addDays(now, 1), 8) });
  const daysToMonday = (8 - now.getDay()) % 7 || 7;
  const monday = at(addDays(now, daysToMonday), 8);
  presets.push({
    label: 'Semaine prochaine',
    detail: `${new Intl.DateTimeFormat('fr-FR', { weekday: 'short' }).format(monday)} 08:00`,
    date: monday,
  });
  return presets;
}

/** Valeur pour un <input type="datetime-local"> (heure locale, sans fuseau). */
export function toDateTimeLocal(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
